export default "__VITE_ASSET__gNYN9_Ru__"